export default "/images/vendor/@coreui/icons/svg/flag/cif-pa.svg?399d9df9ea72a88fe091a2256ea72610";